import {
  CardBody
} from 'reactstrap'
import { truncateString } from '../helper/Text'

const CardPromo = (post : any) => {
  return (
    <div className="shadow CardPromo">
      <div className="thumbnail">
        <img src={(post.thumbnail !== false) ? post.thumbnail : `${process.env.PUBLIC_URL}/images/image-placeholder.png`} alt={post.title} className="cover" />
        <div className="merchant-logo">
          {(post.logo) && (
            <img src={post.logo} alt={post.title} className="img-fluid rounded-circle" />
          )}
        </div>
      </div>
      <CardBody className="d-flex flex-column">
        <a href={post.link} target="_blank" rel="noreferrer" className="stretched-link text-decoration-none mb-auto">
          {truncateString(post.title, 60)}
        </a>
        <div className="d-flex align-items-center end-date text-grey mt-2">
          <i className="a-system-icon icon-clock text-grey"></i>
          <span className="ml-2 text-truncate">{post.periode}</span>
        </div>
      </CardBody>
    </div>
  )
}

export default CardPromo